( function () {
   
    'use strict';

    ( function ( $ ) {
       
        function initializeVideos() {
            var selectedGender = $('#video-select').val(); // Get selected value
            filterVideosByGender(selectedGender);

            // Set the first visible video as active and play it
            var firstVisibleVideo = $('.vid-boxes .vid-come:visible').first();
            if (firstVisibleVideo.length) {
                var firstVideoId = firstVisibleVideo.attr('id').replace('vidlist_', '');
                setActiveVideo(firstVideoId);
            }
        }

    // Filter videos based on gender
    function filterVideosByGender(gender) {
        // Filter video list
        $('.vid-boxes .vid-come').each(function () {
            if ($(this).data('gen-type') === gender || gender === 'all') {
                $(this).closest('li').show();
            } else {
                $(this).closest('li').hide();
            }
        });

        // Filter video player
        $('.play-vid .cvid').each(function () {
            if ($(this).data('gen-type') === gender || gender === 'all') {
                $(this).removeClass('hide-vid');
            } else {
                $(this).addClass('hide-vid');
            }
        });
    }

    // Set the active video
    function setActiveVideo(videoId) {
        // Update the list's active class
        $('.vid-boxes li').removeClass('active');
        $('#vidlist_' + videoId).closest('li').addClass('active');

        // Update the video player
        $('.play-vid .cvid').removeClass('current').addClass('hide-vid');
        $('#vid_' + videoId).removeClass('hide-vid').addClass('current');
        // $('#vid_' + videoId).get(0).play();
    }

    // Handle dropdown change
    $('#video-select').change(function () {
        var selectedGender = $(this).val();
        document.cookie = "wps_preference=" + selectedGender + "; path=/; expires=Thu, 01 Jan 2025 00:00:00 UTC";

        filterVideosByGender(selectedGender);

        // Set the first visible video as active and play it
        var firstVisibleVideo = $('.vid-boxes .vid-come:visible').first();
        if (firstVisibleVideo.length) {
            var firstVideoId = firstVisibleVideo.attr('id').replace('vidlist_', '');
            setActiveVideo(firstVideoId);
        }
    });

    // Handle list item click
    $('.vid-boxes').on('click', '.vid-come', function () {
        var videoId = $(this).attr('id').replace('vidlist_', '');
        setActiveVideo(videoId);
    });

    $(".video-tab-list").click(function () {
      if ($(this).hasClass('active')) {
          return false; // No action if the tab is already active
         
      } else {
          // Pause any currently playing videos or podcasts
          $(".cvid").trigger('pause');

          // Remove active class from all tabs and contents
          $(".video-tab-list").removeClass('active');
          $(".video-tab-list-content").removeClass('active');

          // Add active class to clicked tab and corresponding content
          var tabId = $(this).attr('id');
          $(this).addClass('active');
          $("#" + tabId + "-content").addClass('active');

          // For the Podcasts tab, ensure the first podcast is marked as active
          if (tabId === "podcasts") {
            // Remove the active class from all audio elements
            $(".play-vid audio").removeClass('current').addClass('hide-vid');

            // Add the current class to the first audio element and make it visible
            $(".play-vid audio:first").removeClass('hide-vid').addClass('current');
          //   $(".vid-boxes li").removeClass('active'); 
          //   $(".vid-boxes li:first").addClass('active'); 
            
        }
        if (tabId === "video") {
            // Remove the active class from all audio elements
            $(".play-vid video").removeClass('current').addClass('hide-vid');

            // Add the current class to the first audio element and make it visible
            $(".play-vid video:first").removeClass('hide-vid').addClass('current');
          //   $(".vid-boxes li").removeClass('active'); 
          //   $(".vid-boxes li:first").addClass('active'); 
        }
      }
      return false;
  });
  $(".vid-list li").click(function (e) {
    $(".cvid").trigger('pause');
    $('.vid-list li').removeClass('active');
    $(this).addClass('active');
    var nextvid = $(this).find('.vid-come').attr('id');
    var lastnum = nextvid.split("_").pop();
    $('.cvid').addClass('hide-vid');
    $('.cvid').removeClass('current');
    $("#vid_" + lastnum).removeClass('hide-vid');
    $("#vid_" + lastnum).addClass('current');
    $("#vid_" + lastnum).get(0).play();
});
    // Video hover controls
    var $video = $(".cvid");
    $video.on('mouseover', show);
    $video.on('mouseleave', hide);

    function show() {
        // $(this).attr('controls', ''); // You can manage control visibility here
    }

    function hide() {
        // $(this).removeAttr('controls'); // You can manage control visibility here
    }

    // Click event for video list items
    

    // Handling the video end and switching to the next video
    
  
    // AJAX handler for video category selection
    if ($('.video-podcasts-detail').length > 0) {
        
        $('.vidcat').on('change', function () {
          var catvals = $(this).val();
          var gen_type = $('#video-select').val(); // Get the selected gender from the dropdown
      
          $.ajax({
              type: "POST",
              cache: false,
              url: ssAjax.ajaxurl,
              data: {
                  nonce: ssAjax.nonce,
                  catvals: catvals,
                  gen_type: gen_type, // Send gender filter to the server
                  action: 'getvidlist'
              },
              dataType: 'html',
              success: function (responses) {
                  var ArrNames = responses.split("^*");
                  var html1 = ArrNames[0]; // First part of response (list of videos)
                  var html2 = ArrNames[1]; // Second part of response (video player)
      
                  // Update video list and player
                  $(".replacehtml").html(html1);
                  $(".ajaxcal").html(html2);
      
                  // Reset video player and hide all videos initially
                  $(".cvid").addClass('hide-vid').removeClass('current'); 
      
                  // Show the first video in the updated list as the current one
                  $(".cvid:first").removeClass('hide-vid').addClass('current');
      
                  // Reset and update active class for the first item in the video list
                  $(".vid-boxes li").removeClass('active'); 
                  $(".vid-boxes li:first").addClass('active'); 
      
                  // Rebind click and hover events after the content is updated
                  $(".vid-boxes .vid-come").click(function () {
                      var videoId = $(this).attr('id').replace('vidlist_', '');
                      setActiveVideo(videoId);
                  });
      
                  // If a video is currently playing, make sure it starts playing in the new selection
                  var video = $(".current")[0];
                  if (video) {
                      video.play();
                  }
              }
          });
      });
      
      $('#video-select').change(function () {
        var selectedValue = $(this).val(); // Get the selected gender (men or women)
        var catvals = $('.vidcat').val(); // Get the selected category
        var tyoevals = $('.video-tab-list.active').attr('id');
        // console.log(tyoevals);
        
        if(tyoevals !== 'podcasts') {
        $.ajax({
            type: "POST",
            cache: false,
            url: ssAjax.ajaxurl,
            data: {
                nonce: ssAjax.nonce,
                catvals: catvals,
                gen_type: selectedValue, // Send gender filter to the server
                action: 'getvidlist'
            },
            dataType: 'html',
            success: function (responses) {
                var ArrNames = responses.split("^*");
                var html1 = ArrNames[0]; // First part of response (video list)
                var html2 = ArrNames[1]; // Second part of response (video player)
    
                // Update video list and player
                $(".replacehtml").html(html1);
                $(".ajaxcal").html(html2);
    
                // Reset video player and hide all videos initially
                $(".cvid").addClass('hide-vid').removeClass('current'); 
    
                // Show the first video in the updated list as the current one
                $(".cvid:first").removeClass('hide-vid').addClass('current');
    
                // Reset and update active class for the first item in the video list
                $(".vid-boxes li").removeClass('active');
                $(".vid-boxes li:first").addClass('active');
    
                // Bind the click event to update the active video
                $(".vid-boxes .vid-come").click(function () {
                    var videoId = $(this).attr('id').replace('vidlist_', '');
                    setActiveVideo(videoId);
                });
    
                // If a video is currently playing, make sure it starts playing in the new selection
                var video = $(".current")[0];
                if (video) {
                    video.play();
                }
            }
            
        });
       
        }
      });
    
      // Function to handle setting active video
      function setActiveVideo(videoId) {
        $(".vid-boxes li").removeClass('active');
    
        // Add the active class to the selected video list item
        $("#vidlist_" + videoId).addClass('active');
        
        // Hide all videos and then show the selected one
        $(".cvid").removeClass('current').addClass('hide-vid');
        $("#vid_" + videoId).removeClass('hide-vid').addClass('current');
        
        // Play the selected video
       // var video = $("#vid_" + videoId)[0];
        // if (video) {
        //     video.play();
        // }
      }
     
    }
  
    initializeVideos();
       
    } )(jQuery);
} )();

